import { PAGE_NAME } from "../../../const/analytics";
import { enrollmentType } from "../../../const/enrollmentConsts";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
var analyticsHandler = function (_a) {
    var clientId = _a.clientId, product = _a.product, statementsEnrollmentType = _a.statementsEnrollmentType;
    var ELECTRONIC = enrollmentType.ELECTRONIC, ELECTRONIC_AND_PAPER = enrollmentType.ELECTRONIC_AND_PAPER, PAPER = enrollmentType.PAPER;
    // eslint-disable-next-line default-case
    switch (statementsEnrollmentType) {
        case PAPER:
            triggerAnalytics({
                clientName: clientId,
                product: product,
                pageName: PAGE_NAME.VIEW,
                pageSubFunction: "unenrolled",
            });
            break;
        case ELECTRONIC:
        case ELECTRONIC_AND_PAPER:
            triggerAnalytics({
                clientName: clientId,
                product: product,
                messageType: "successfully enrolled statements",
                pageName: PAGE_NAME.VIEW,
                pageSubFunction: "enrolled",
            });
    }
};
export default analyticsHandler;
